<template>
  <div class="change-password">
    <div class="pb-3 change-password-title text-center">
      <img src="@/assets/images/change-password.svg" alt="change-password" />
      <h1 class="mt-2">重置密碼</h1>
    </div>
    <div class="card change-password-card">
      <div class="card-body p-4">
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="password" class="form-label">新密碼</label>
            <div
              class="input-group border rounded-pill"
              :class="{ 'is-invalid': errMsg }"
            >
              <input
                v-model="form.password"
                :type="show_password ? 'text' : 'password'"
                class="form-control border-0 rounded-pill"
                :class="{ 'is-invalid': errMsg }"
                id="password"
                placeholder="請輸入新密碼"
                required
              />
              <span
                class="input-group-text show-password border-0 rounded-pill"
                role="button"
                @click="showedPassword"
              >
                <i
                  class="bi"
                  :class="show_password ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
                ></i>
              </span>
            </div>
          </div>
          <div class="mb-3">
            <label for="againPassword" class="form-label"
              >再輸入一次新密碼</label
            >
            <div
              class="input-group border rounded-pill"
              :class="{ 'is-invalid': errMsg }"
            >
              <input
                v-model="form.password_confirmation"
                :type="show_password ? 'text' : 'password'"
                class="form-control border-0 rounded-pill"
                :class="{ 'is-invalid': errMsg }"
                id="againPassword"
                placeholder="請輸入新密碼"
                required
              />
              <span
                class="input-group-text show-password border-0 rounded-pill"
                role="button"
                @click="showedPassword"
              >
                <i
                  class="bi"
                  :class="show_password ? 'bi-eye-slash-fill' : 'bi-eye-fill'"
                ></i>
              </span>
            </div>
          </div>
          <div class="text-danger text-center mb-3" v-if="errMsg">
            {{ errMsgInfo }}
          </div>
          <button
            type="submit"
            class="btn btn-info rounded-pill change-password-submit"
          >
            確認
          </button>
        </form>
      </div>
    </div>
    <small class="pt-3 d-block text-center fw-light">
      Client： <span class="text-primary">{{ clientName }}</span>
      <span class="ps-3">
        Version： <span class="text-primary">{{ version }}</span>
      </span>
    </small>
    <small class="p-3 d-block text-center fw-light"
      >© 2021 - {{ new Date().getFullYear() }} 釦釘資訊工作室 All rights
      reserved.</small
    >
  </div>
</template>

<script>
import { auth } from '@/http/api/auth.js'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'ChangePassword',
  data () {
    return {
      version: process.env.PACKAGE_VERSION,
      form: {
        email: this.$route.query.email,
        password: null,
        password_confirmation: null,
        token: this.$route.query.token
      },
      show_password: false
    }
  },
  computed: {
    ...mapState(['errMsg']),
    ...mapGetters(['clientName', 'errMsgInfo'])
  },
  watch: {
    form: {
      handler () {
        this.ClearErrMsg()
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations([
      'Loaded',
      'Loading',
      'SetErrMsgKey',
      'SetErrMsg',
      'ClearErrMsg'
    ]),
    showedPassword () {
      this.show_password = !this.show_password
    },
    submitForm () {
      const vm = this
      if (vm.form.password !== vm.form.password_confirmation) {
        vm.SetErrMsg({
          錯誤: '密碼不相同，請重新輸入一次'
        })
      } else {
        vm.Loading()
        auth
          .changePassword(vm.form)
          .then((res) => {
            const { data } = res
            if (res.status <= 201 && data.status === 'success') {
              localStorage.removeItem('codingIt_admin_token')
              vm.$router.push({ name: 'Login' })
            } else {
              vm.SetErrMsg(data.errMsg)
            }
            vm.Loaded()
          })
          .catch((err) => {
            vm.SetErrMsg(err)
            vm.Loaded()
          })
      }
    }
  }
}
</script>

<style lang="scss">
.change-password {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  &-title {
    max-width: 360px;
    width: 90%;
    margin: auto;
    color: #fff;
    a {
      font-size: 24px;
      color: #fff;
      padding-left: 1rem;
      padding-right: 1rem;
      transition: padding 0.3s ease-in-out;
      &:hover {
        color: #fff;
        padding-left: 0;
        padding-right: 2.5rem;
      }
    }
  }
  &-card {
    max-width: 360px;
    width: 90%;
    margin: auto;
  }
  &-submit {
    color: #fff;
    width: 100%;
    transition: box-shadow 0.3s ease-in-out;
    background: $linear-gradient;
    box-shadow: 0px 4px 4px $shadow-color;
    &:hover {
      color: #fff;
      box-shadow: 0px 7px 7px $shadow-color;
    }
  }
  .show-password {
    background-color: #fff;
    border: none;
    color: $gray;
  }
}
</style>
